"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchSetLoadingSlot = exports.StytchLoadingSlot = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var StytchLoadingSlot;
(function (StytchLoadingSlot) {
    StytchLoadingSlot["EMAIL_SIGN_IN"] = "EMAIL_SIGN_IN";
    StytchLoadingSlot["EMAIL_SIGN_UP"] = "EMAIL_SIGN_UP";
    StytchLoadingSlot["EMAIL_EXCHANGE_CODE"] = "EMAIL_EXCHANGE_CODE";
    StytchLoadingSlot["EMAIL_RESEND_MESSAGE"] = "EMAIL_RESEND_MESSAGE";
    StytchLoadingSlot["CRYPTO_SIGN_IN"] = "CRYPTO_SIGN_IN";
    StytchLoadingSlot["CRYPTO_SIGN_UP"] = "CRYPTO_SIGN_UP";
    StytchLoadingSlot["CRYPTO_EXCHANGE_CODE"] = "CRYPTO_EXCHANGE_CODE";
    StytchLoadingSlot["LOAD_AUTHENTICATION"] = "LOAD_AUTHENTICATION";
    StytchLoadingSlot["PHONE_SIGN_IN"] = "PHONE_SIGN_IN";
    StytchLoadingSlot["PHONE_SIGN_UP"] = "PHONE_SIGN_UP";
    StytchLoadingSlot["PHONE_EXCHANGE_CODE"] = "PHONE_EXCHANGE_CODE";
    StytchLoadingSlot["PHONE_RESEND_CODE"] = "PHONE_RESEND_CODE";
    StytchLoadingSlot["SIGN_OUT"] = "SIGN_OUT";
    StytchLoadingSlot["REFRESH_TOKEN"] = "REFRESH_TOKEN";
    StytchLoadingSlot["GET_CURRENT_USER"] = "GET_CURRENT_USER";
})(StytchLoadingSlot = exports.StytchLoadingSlot || (exports.StytchLoadingSlot = {}));
exports.stytchSetLoadingSlot = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/SET_LOADING_SLOT');
